/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RankListResponseWrapper } from '../../models/rank-list-response-wrapper';

export interface GetRankList$Params {
  month: string;
  roomId: string;
  level: string;
  nameSpace: string;
}

export function getRankList(http: HttpClient, rootUrl: string, params: GetRankList$Params, context?: HttpContext): Observable<StrictHttpResponse<RankListResponseWrapper>> {
  const rb = new RequestBuilder(rootUrl, getRankList.PATH, 'get');
  if (params) {
    rb.query('month', params.month, {});
    rb.path('roomId', params.roomId, {});
    rb.query('level', params.level, {});
    rb.path('nameSpace', params.nameSpace, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RankListResponseWrapper>;
    })
  );
}

getRankList.PATH = '/api/namespaces/{nameSpace}/rooms/{roomId}/ranklist';
